import { Grid, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DrawerContentContainerGrid = styled(Grid)({
  height: "100%",
  position: "relative",
  flexDirection: "column",
  overflow: "auto",
  overflowX: "hidden",
});

export const DrawerContentGrid = styled(Grid)({
  height: "100%",
  overflowY: "auto",
  overflowX: "hidden",
});

export const CloseIconButton = styled(IconButton)(({ theme }) => ({
  cursor: "pointer",
  color: theme.palette.black.main,
  margin: theme.spacing(1.5),
  height: "fit-content",
}));
